import React, { FunctionComponent, PropsWithChildren } from 'react';
import { DisneyOneID } from '@/components/DisneyOneID';

export const Membership: FunctionComponent<PropsWithChildren<any>> = (
  props,
) => {
  return (
    <>{props.membershipType == 'DISNEY_ONEID' && <DisneyOneID {...props} />}</>
  );
};
